import { VisibilityState } from "@tanstack/react-table";
import React from "react";
import { ReactComponent as FilterIcon } from "../../../images/icons/filterLines.svg";
import { StandardSelectOption } from "../../selector/parts/SelectOption";
import { Selector } from "../../selector/Selector";
import { columnDefs } from "./getBalancesTableColumns";

const managedColumns = Object.fromEntries(
  Object.entries(columnDefs).filter(([, def]) => def.optional),
);

const options: StandardSelectOption[] = Object.entries(managedColumns).map(
  ([id, props]) => ({
    value: id,
    data: {
      label: props.name,
      description: props.description,
    },
  }),
);

export function CustomiseTableSelector({
  setState,
  state,
}: {
  state: VisibilityState;
  setState: React.Dispatch<React.SetStateAction<VisibilityState>>;
}) {
  return (
    <Selector
      size="sm"
      placeholder="Customise"
      expandIcon={<FilterIcon />}
      options={options}
      enableMultiSelect
      enableDeselect
      values={Object.keys(managedColumns).filter((id) => state[id])}
      onChange={(values) => {
        const newState = Object.fromEntries(
          Object.keys(managedColumns).map((id) => [
            id,
            values.some((value) => value === id),
          ]),
        );
        setState((oldState) => ({ ...oldState, ...newState }));
      }}
      buttonProps={{
        backgroundColor: "white",
      }}
    />
  );
}
